/** Uppercase section heading used throughout the Test Results pane. */
export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <p className="text-muted-foreground text-xs font-semibold uppercase tracking-wide">
      {children}
    </p>
  )
}
